/*
Akhila 03/20/2023 2699762545 Added validation for stepper hidden
Sohel 03/20/2023 2699762545 Fixed Stepper hide issue
Sohel 03/22/2023 2699762545 Integrated Save and Get API
Sohel 03/23/2023 2699762545 enable Steppers
Guru Prasad 03/23/2023 2699762545 Fixed stepper UI
Dilip 03/23/2023 2699762545 added prior letter Stepper
Rohini 03/23/2023 2699762545 added css for the stepper
Prakash 03/24/2023 2699762545 Fixed Overflow issue with scroll.
Sohel 03/27/2023 2699762545 Payload Changes
Prakash 03/27/2023 2699762545 Added classname for scroll styling.
Akhila 03/28/2023 2699762545 Rename stepper label
Sohel 03/29/2023 2699762545 Rename Stepper label
Sohel 03/30/2023 2699762545 Change letter Type Value
Ravi 04/12/2023 2699762545 Added unsaved popup changes
Akhila 05/24/2024 2699762545 role access implemeneted
*/
import {Button, makeStyles, Stepper, StepLabel, Step} from '@material-ui/core';
import React, {useEffect, useState, useRef} from 'react';
import reusableInputStyles from '../../../components/InputStyles';
import {ArrowBack} from '@material-ui/icons';
import StepConnector from '@material-ui/core/StepConnector';
import {withStyles} from '@material-ui/core/styles';
import {backButtonText} from '../../../util/Content';
import NumberStepIcon from '../../../components/customStepIcon';
import BasicInfo from './BasicInfo';
import LetterFields from './LetterFields';
import LetterFormat from './LetterFormat/index';
import ClientInformation from './ClientInformation';
import Dispositions from './Dispositions';
import LetterGroup from './LetterGroup';
import {useSelector, useDispatch} from 'react-redux';
import useUnsavedChangesWarning from '../../../util/CustomHooks';
import {setAlertData} from '../../../redux/reducers/UnsavedChangesAlertReducer';
import {PriorLetters} from './PriorLetters';
import {LETTER_MAINTENANCE} from '../../../constants/ReusableRoleAccess';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepperIcon: {
    '& .MuiStepLabel-iconContainer': {
      '& .MuiStepIcon-root': {
        width: '35px !important',
        height: '35px !important',
      },
    },
    '& .MuiStepIcon-completed': {
      color: '#320469',
    },
    '& .MuiStepIcon-active': {
      color: '#320469',
    },
    '& .MuiStepLabel-labelContainer': {
      '& .MuiTypography-root': {
        fontSize: '1rem',
        fontWeight: 600,
        fontFamily: 'articulat-cf, sans-serif !important',
      },
    },
  },
}));
const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const AddLetterMaintenance = ({setValue, editExisting}) => {
  const stepperClasses = useStyles();
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const showAlertRef = useRef(false);
  const [steps, setSteps] = useState([
    'Basic Info',
    'Format',
    'Fields',
    'Client Info',
    'Dispositions',
    'Letter Group',
  ]);
  const {basicInfoData} = useSelector(({newLetterMaintenance}) => newLetterMaintenance);
  const [activeStep, setActiveStep] = React.useState(0);
  const [hidden, setHidden] = useState(false);
  const {onDirty, onPristine} = useUnsavedChangesWarning();
  const {roleData} = useSelector(({role}) => role);
  const LetterMainAccess = roleData?.window?.[LETTER_MAINTENANCE]?.['LM'];
  const changeDirty = useRef(true);
  const handleDirty = (dirty, isFixed) => {
    if (isFixed === 'fixed') {
      showAlertRef.current = dirty;
      changeDirty.current = false;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
    if (isFixed === 'reset') {
      showAlertRef.current = false;
      changeDirty.current = true;
      onPristine();
    }
    if (changeDirty.current) {
      showAlertRef.current = dirty;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
  };
  const alertProps = {
    showAlertRef,
    handleDirty,
  };
  useEffect(() => {
    if (hidden) {
      const StepName = [
        'Basic Info',
        'Client Info',
        'Status',
        'Prerequisite',
        'Fields',
        'Letter Group',
      ];
      setSteps(StepName);
    } else {
      const StepName = [
        'Basic Info',
        'Client Info',
        'Status',
        'Prerequisite',
        'Format',
        'Fields',
        'Letter Group',
      ];
      setSteps(StepName);
    }
  }, [hidden]);

  const handleNext = (value) => {
    setActiveStep((prevActiveStep) => (value ? Number(value) + 1 : prevActiveStep + 1));
  };

  const handleBack = () => {
    if (showAlertRef.current) {
      dispatch(
        setAlertData({
          showAlert: showAlertRef.current,
          alertCallback: () => {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
          },
        }),
      );
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };
  useEffect(() => {
    if (basicInfoData?.letterCode) {
      if (basicInfoData?.isDraft === 'N') {
        setActiveStep(0);
      } else {
        setActiveStep(basicInfoData?.lastStep || 0);
      }
    }
  }, [basicInfoData?.letterCode]);

  useEffect(() => {
    if (basicInfoData?.letterType) {
      setHidden(basicInfoData?.letterType === 'Print Service');
    }
  }, [basicInfoData]);
  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
    case 0:
      return (
        <BasicInfo
          handleHideStep={(e) => setHidden(e)}
          activeStep={activeStep}
          handleNext={handleNext}
          LetterMainAccess={LetterMainAccess}
          editExisting={editExisting}
          {...alertProps}
        />
      );
    case 1:
      return (
        <ClientInformation
          handleNext={handleNext}
          LetterMainAccess={LetterMainAccess}
          handleBack={handleBack}
          editExisting={editExisting}
          {...alertProps}
        />
      );

    case 2:
      return (
        <Dispositions
          handleNext={handleNext}
          LetterMainAccess={LetterMainAccess}
          handleBack={handleBack}
          editExisting={editExisting}
          {...alertProps}
        />
      );

    case 3:
      return (
        <PriorLetters
          handleNext={handleNext}
          LetterMainAccess={LetterMainAccess}
          handleBack={handleBack}
          editExisting={editExisting}
          {...alertProps}
        />
      );

    case 4:
      return hidden ? (
        <LetterFields
          handleNext={handleNext}
          LetterMainAccess={LetterMainAccess}
          handleBack={handleBack}
          editExisting={editExisting}
          hidden={hidden}
          {...alertProps}
        />
      ) : (
        <LetterFormat
          handleNext={handleNext}
          LetterMainAccess={LetterMainAccess}
          handleBack={handleBack}
          editExisting={editExisting}
          hidden={hidden}
          {...alertProps}
        />
      );
    case 5:
      return hidden ? (
        <LetterGroup
          handleBack={handleBack}
          LetterMainAccess={LetterMainAccess}
          setValue={setValue}
          editExisting={editExisting}
          hidden={hidden}
          {...alertProps}
        />
      ) : (
        <LetterFields
          handleNext={handleNext}
          LetterMainAccess={LetterMainAccess}
          handleBack={handleBack}
          editExisting={editExisting}
          hidden={hidden}
          {...alertProps}
        />
      );
    case 6:
      return (
        <LetterGroup
          handleBack={handleBack}
          LetterMainAccess={LetterMainAccess}
          setValue={setValue}
          editExisting={editExisting}
          {...alertProps}
        />
      );
    }
  };
  const isCurrentStepCompleted = basicInfoData?.isDraft === 'N';
  return (
    <>
      <div className="button-table-spacing-mb justify-content-between new-standard-textfields">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn ${classes.buttonRoot}`}
          onClick={() => {
            if (showAlertRef.current) {
              dispatch(
                setAlertData({
                  showAlert: showAlertRef.current,
                  alertCallback: () => {
                    setValue(0);
                  },
                }),
              );
            } else {
              setValue(0);
            }
          }}
        >
          <ArrowBack className="mr-2" />
          {backButtonText}
        </Button>
      </div>
      <div className={classes.root} style={{border: '1px solid #cfcfcf'}}>
        <Stepper
          activeStep={activeStep}
          connector={<QontoConnector />}
          className="stepper-overflow"
        >
          {steps.map((label, index) => (
            <Step
              key={label}
              completed={
                index <= activeStep || index <= basicInfoData?.lastStep || isCurrentStepCompleted
              }
              onClick={() => {
                if (
                  index <= basicInfoData?.lastStep ||
                  isCurrentStepCompleted ||
                  index <= activeStep
                ) {
                  if (showAlertRef.current) {
                    dispatch(
                      setAlertData({
                        showAlert: showAlertRef.current,
                        alertCallback: () => {
                          setActiveStep(index);
                        },
                      }),
                    );
                  } else {
                    setActiveStep(index);
                  }
                } else if (index < activeStep) {
                  setActiveStep(index);
                }
              }}
              style={{cursor: 'pointer'}}
            >
              <StepLabel
                className={`${stepperClasses.stepperIcon} ${
                  activeStep === index ? 'completedStyle' : null
                }`}
                StepIconComponent={NumberStepIcon}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <div>
          <div style={{padding: '1rem 0.5rem'}}>{getStepContent(activeStep)}</div>
        </div>
      </div>
    </>
  );
};

export default AddLetterMaintenance;
